// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__6MqAb","notification--error":"styles_notification--error__p0qYo"};